import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

const GrantsList = (props) => {

    const handleSelectionChanged = (e) => {
        props.onSelectionChanged(e);
    }
        return (
            <Row className='mb-1'>
                        <Col>
                            <div style={{ height: '100%', width: '100%' }}>
                            <DataGrid
                                rows={props.data?.map(x => { return { id: x.grantId, ...x } }) || []}
                                checkboxSelection
                                onRowSelectionModelChange={handleSelectionChanged}
                                onRowDoubleClick={props.onRowDoubleClick}
                                autoHeight={true}
                                rowHeight={35}
                                initialState={{
                                    pagination: { paginationModel: { pageSize: 25 } },
                                }}
                                columns={[
                                {
                                    headerName: 'Name',
                                    field: 'name',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Start Date',
                                    field: 'startDate',
                                    valueFormatter: (params) => moment(params.value).format('MMM Do YYYY'),
                                    flex: 3,
                                },
                                {
                                    headerName: 'End Date',
                                    field: 'endDate',
                                    valueFormatter: (params) => moment(params.value).format('MMM Do YYYY'),
                                    flex: 3,
                                }
                            ]}
                            sx={{
                                backgroundColor: 'white'
                            }}
                            rowData={props.data}>
                        </DataGrid>
                    </div>
                </Col>
            </Row>
        )
    }

export default GrantsList